import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { GarageEntity as Entity } from 'src/entities/garageEntity';
import { HavePaginationEntity } from 'src/entities/HavePagination.entity';

const requestPathBase = '/api/v4/master/garages';
export const queryKey = 'useGaragesRequest';

const getResources = async (page: number, sortCondition: string, searchCondition: string, per?: number) => {
  const requestParams = [
    `page=${page + 1}`,
    sortCondition ? `sort_condition=${sortCondition}` : '',
    searchCondition ? `${searchCondition}` : '',
    per ? `per=${per}` : '',
  ].filter((maybe) => maybe).join('&');

  const requestPath = [
    requestPathBase,
    requestParams,
  ].join('?');

  const response: AxiosResponse<HavePaginationEntity<Entity>> = await axios.get<HavePaginationEntity<Entity>>(requestPath);

  return response.data;
};

export const useGaragesRequest = (
  page: number,
  sortCondition: string,
  searchCondition: string,
  per?: number,
  options?: Omit<UseQueryOptions<HavePaginationEntity<Entity>>, 'queryKey' | 'queryFn'>
) => useQuery({
  queryKey: [queryKey, { page, sortCondition, searchCondition, per }],
  queryFn: () => getResources(page, sortCondition, searchCondition, per),
  ...options
});
